import { InjectionToken, Provider } from '@angular/core';
import { SplitFactory } from '@splitsoftware/splitio';

export const SPLIT_API_KEY = new InjectionToken<string | null>('SPLIT_API_KEY');

export const SPLIT_FACTORY = new InjectionToken<SplitIO.ISDK>('SPLIT_FACTORY');

export function splitFactory(apiKey: string | null): SplitIO.ISDK {
  return SplitFactory(<SplitIO.IBrowserSettings>{
    core: { authorizationKey: apiKey || 'localhost' },
    startup: { retriesOnFailureBeforeReady: 2 },
    storage: {
      type: 'LOCALSTORAGE',
    },
  });
}

export const SPLIT_FACTORY_PROVIDERS: Provider[] = [
  {
    deps: [SPLIT_API_KEY],
    provide: SPLIT_FACTORY,
    useFactory: splitFactory,
  },
];
